var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiThumbsDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3006 7.5835C14.3006 8.27385 13.7409 8.8335 13.0506 8.8335C12.3602 8.8335 11.8006 8.27385 11.8006 7.5835V2.5835C11.8006 1.89314 12.3602 1.3335 13.0506 1.3335C13.7409 1.3335 14.3006 1.89314 14.3006 2.5835V7.5835Z",
    fill: "#252919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 7.72239V3.19689C10.9672 2.5656 10.6106 1.98849 10.0459 1.70618L10.0044 1.68541C9.54154 1.45398 9.03116 1.3335 8.51368 1.3335L4.00024 1.3335C3.20577 1.3335 2.52175 1.89426 2.36594 2.6733L1.36594 7.6733C1.15968 8.70462 1.9485 9.66683 3.00024 9.66683H5.96723V13.0002C5.96723 13.9206 6.71343 14.6668 7.6339 14.6668C8.09414 14.6668 8.46723 14.2937 8.46723 13.8335V13.2779C8.46723 12.5567 8.70116 11.8549 9.1339 11.2779L10.3006 9.72239C10.7333 9.1454 10.9672 8.44362 10.9672 7.72239Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiThumbsDown);
export default __webpack_public_path__ + "static/media/ai-thumbs-down.35cc63d6d78edf0558d5752d4a7fb85e.svg";
export { ForwardRef as ReactComponent };